import { io } from 'socket.io-client';

import { API_URL } from './config';

export const socket = io(API_URL, {
  extraHeaders: {
    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token') as string)}`,
  },
});
